<style lang="scss">
.monitorMachineMoldTable .el-progress-bar__outer {
  background: #606672;
}

.monitorMachineMoldTable .el-progress__text {
  color: #ffffff;
}

.monitorMachineMoldTable::before {
  z-index: inherit;
}

.monitorMachineMoldTable.el-table {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table--border:after,
.monitorMachineMoldTable.el-table--group:after,
.monitorMachineMoldTable.el-table:before {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table tr {
  background-color: transparent;
}

.monitorMachineMoldTable.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #33333a !important;
}

.monitorMachineMoldTable .el-table td.gutter,
.monitorMachineMoldTable.el-table th.gutter {
  background: rgba(7, 53, 245, 1) !important;
}

//.monitorMachineMoldTable .el-table__body-wrapper {
//  background: #1d1d24;
//}

// 滚动条的宽度
.monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

// 滚动条的滑块
.monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

/*滚动条里面轨道*/
// .monitorMachineMoldTable .el-table__body-wrapper::-webkit-scrollbar-track {
// 	border-radius: 2px;
// 	background: #1D1D24;
// }
</style>

<style lang="scss" scoped="scoped">
.cell-class-name {
  border-bottom: 1px solid red !important;
}
.biankuang {
  border: 4px solid rgba(108, 167, 255, 1);
  border-radius: 5px;
  box-shadow: 0px 0px 30px 0px rgba(45, 53, 255, 1) inset;
  box-shadow: 0px 0px 80px 0px rgba(45, 53, 255, 1) inset;
}

.yongxinSmallTitle {
  background-image: url(../../../../../../../assets/img/web/yongxin/small_title_bg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>

<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;padding: 0px 20px 10px 10px; background: rgba(3, 0, 108, 1)">
    <div class="biankuang">
      <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;padding-bottom: 10px;">
        <div class="yongxinSmallTitle" style="width: 100%;height: 40px;color:white;display:flex;justify-content:center;align-items:center;font-size:20px">
          质检数据
        </div>
      </div>
      <div ref="sum" style="padding: 20px;display: flex;justify-content: space-around;">
        <div style="color: #FF8946;text-align: center;">
          <p style="font-weight: bold;font-size: 22px;">首检</p>
          <div v-if="summary" style="display: flex;justify-content: space-between;margin-top:10px;">
            <div style="text-align: center;">
              <p style="color: white;font-weight: bold;font-size: 16px;">待检</p>
              <p style="font-weight: bold;font-size: 22px;">{{ summary.firstPendingCheck}}</p>
            </div>
            <div style="text-align: center;margin: 0px 10px;">
              <p style="color: white;font-weight: bold;font-size: 16px;">今日已检</p>
              <p style="font-weight: bold;font-size: 22px;">{{summary.firstChecked }}</p>
            </div>
            <div style="text-align: center;">
              <p style="color: white;font-weight: bold;font-size: 16px;">合格率</p>
              <p  style="font-weight: bold;font-size: 22px;">{{ summary.firstQualifiedRate }}%</p>
            </div>
          </div>
        </div>
        <div v-if="summary" style="color: #DDF63E;text-align: center;">
          <p style="font-weight: bold;font-size: 22px;">巡检</p>
          <div style="display: flex;justify-content: space-between;margin-top:10px;">
            <div style="text-align: center;">
              <p style="color: white;font-weight: bold;font-size: 16px;">待检</p>
              <p style="font-weight: bold;font-size: 22px;">{{ summary.spotPendingCheck }}</p>
            </div>
            <div style="text-align: center;margin: 0px 10px;">
              <p style="color: white;font-weight: bold;font-size: 16px;">今日已检</p>
              <p style="font-weight: bold;font-size: 22px;">{{ summary.spotChecked }}</p>
            </div>
            <div style="text-align: center;">
              <p style="color: white;font-weight: bold;font-size: 16px;">合格率</p>
              <p  style="font-weight: bold;font-size: 22px;">{{ summary.spotQualifiedRate }}%</p>
            </div>
          </div>
        </div>
        <div v-if="summary" style="color: #2FFECC;text-align: center;">
          <p style="font-weight: bold;font-size: 22px;">末检</p>
          <div style="display: flex;justify-content: space-between;margin-top:10px;">
            <div style="text-align: center;">
              <p style="color: white;font-weight: bold;font-size: 16px;">待检</p>
              <p style="font-weight: bold;font-size: 22px;">{{ summary.endPendingCheck }}</p>
            </div>
            <div style="text-align: center;margin: 0px 10px;">
              <p style="color: white;font-weight: bold;font-size: 16px;">今日已检</p>
              <p style="font-weight: bold;font-size: 22px;">{{ summary.endChecked }}</p>
            </div>
            <div style="text-align: center;">
              <p style="color: white;font-weight: bold;font-size: 16px;">合格率</p>
              <p  style="font-weight: bold;font-size: 22px;">{{ summary.endQualifiedRate }}%</p>
            </div>
          </div>
        </div>
      </div>
      <div :style="{ height: contentHeight + 'px' }" style="padding: 0px 16px;">
        <el-table ref="table" class="monitorMachineMoldTable" :data="list" style="width: 100%" :max-height="contentHeight" :row-style="{ height: rowHeight + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: 'rgba(7, 53, 245, 1)', color: '#FFFFFF', 'font-size': '16px' }" :header-cell-style="{ background: 'rgba(7, 53, 245, 1)', color: 'white', padding: '0px', height: '42px', borderColor: 'transparent', 'font-size': '16px' }" cell-class-name="cell-class-name">
          <el-table-column :label="$t('shebeimingcheng')">
            <template slot-scope="scope">
              <div style="font-size: 14px;font-weight: bold;">
                {{ $t(scope.row.equipmentName) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('chanpinmingcheng')">
            <template slot-scope="scope">
              <div style="font-size: 14px;font-weight: bold;">
                {{ $t(scope.row.materialName) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('jihuadanhao')">
            <template slot-scope="scope">
              <div style="font-size: 14px;font-weight: bold;">
                {{ $t(scope.row.planNo) }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column :label="$t('jianyanleixing')">
            <template slot-scope="scope">
              <div style="font-weight: bold;font-size: 15px;border-radius: 2px;height: 30px;width: 76px;display: flex;justify-content: center;align-items: center;color:rgba(255, 137, 70, 1) ;border:1px solid rgba(255, 137, 70, 1) ;background-color: rgba(255, 137, 70, 0.2);">
                {{ $t({ '1': 'shoujian', '2': 'choujian', '3': 'mojian', '4': 'chengpinjian' }[scope.row.inspectionType]) }}
              </div>
            </template>
          </el-table-column> -->
          <el-table-column :label="$t('jianyanfangshi')">
            <template slot-scope="scope">
              <div style="font-size: 14px;font-weight: bold;">
                {{ scope.row.inspectionMethod && $t(scope.row.inspectionMethod.name) }}
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('任务创建时间')">
            <template slot-scope="scope">
              <div style="font-size: 14px;font-weight: bold;">
                {{ dayjs.unix(scope.row.createTime / 1000).format('MM-DD HH:mm:ss') }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_monitor_machine_model_machine_wait',
  components: {},
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listData();
    }
  },
  data() {
    return {
      interval: null,
      timer: null,
      contentHeight: 0,
      rowHeight: 0,
      list: [],
      summary: {},
      isStopListScroll: false
    };
  },
  created() {
    this.timer = setInterval(() => {
      this.listData();
    }, 120000);
    this.listData();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.setAutoScroll();
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    async listData() {
      let response = await this.http.get('/custom/yongxin/quality/board/summaryQualityCheck', {});
      this.summary = response.data.summary;
      this.list = response.data.datas;
    },
    setAutoScroll() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      const listDiv = this.$refs.table.bodyWrapper;
      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
            this.isStopListScroll = true;
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
      }, 100);
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.titleBar) {
          return;
        }
        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - this.$refs.sum.offsetHeight - 20;
        this.rowHeight = (this.contentHeight - 42 - 5) / 6;
      }, 800);
    }
  }
};
</script>
